import type { PropsWithChildren } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export const SlidePadding = ({ children }: PropsWithChildren) => {
  return (
    <Box
      width="100%"
      height="100%"
      py="112px"
      px="space16"
      justifyContent="center"
      alignItems="center"
    >
      {children}
    </Box>
  );
};
